import { useState } from "react";
import ReasonDialog from "./ReasonDialog";
import { Box, Link, Switch } from "@mui/material";

const NoWorkSwitch = ({ reason, onReasonChange, ...props }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
    >
      <Switch
        {...props}
        onChange={(e) => {
          if (e.target.checked) {
            setDialogOpen(true);
          }
          props.onChange(e);
        }}
      />
      <Link
        onClick={() => {
          setDialogOpen(true);
        }}
      >
        Reason
      </Link>
      <ReasonDialog
        disabled={props.disabled}
        title="No Work Reason"
        value={reason}
        open={dialogOpen}
        handleClose={() => {
          setDialogOpen(false);
        }}
        onSubmit={(newReason) => {
          onReasonChange(newReason);
          setDialogOpen(false);
        }}
      />
    </Box>
  );
};

export default NoWorkSwitch;
